import { Error } from '../../../../ErrorHandling';
import { ProductLicensesResource } from '../../Types';

export interface Waiting {
  kind: 'waiting';
}

export interface Loading {
  kind: 'loading';
}

export interface Ready {
  kind: 'ready';
  productLicensesResource: ProductLicensesResource;
}

export type ProductLicensesState = Waiting | Loading | Ready | Error;

export const waiting = (): Waiting => ({
  kind: 'waiting',
});

export const loading = (): Loading => ({
  kind: 'loading',
});

export const ready = (productLicensesResource: ProductLicensesResource): Ready => ({
  kind: 'ready',
  productLicensesResource,
});
